import { useQuery } from '@tanstack/react-query'

import { permissionInstance } from '@/modules/permission'

export function useUserPermissionQuery({ personaId }: { personaId?: string }) {
  return useQuery({
    queryKey: ['userPermission', personaId],
    queryFn: async () =>
      await permissionInstance.getUserPermissions(personaId!),
    enabled: !!personaId,
    staleTime: Infinity
  })
}
